import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { TaskCase } from '../interface/task.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class TaskCaseService {
  readonly baseUrl = `${this.env.URL_API_V1}/taskCase`;

  constructor(private readonly http: HttpClient, private env: EnvService) {}

  taskCreated = new Subject<TaskCase>();
  taskDeleted = new Subject<TaskCase>();
  taskFinished = new Subject<TaskCase>();
  taskUpdated = new Subject<any>();

  //RAS task sidebar
  updateStateTask = new Subject<any>();
  createTaskCase(taskCase) {
    return this.http.post<TaskCase[]>(`${this.baseUrl}/create`, taskCase);
  }

  getTaskCase(id) {
    return this.http.get<TaskCase[]>(`${this.baseUrl}/get/${id}`);
  }

  getTaskByCase(id) {
    return this.http.get<TaskCase[]>(
      `${this.baseUrl}/getTaskByCase/${id}/${Date.now()}`
    );
  }

  getTaskAndFiles(id) {
    return this.http.get<TaskCase[]>(
      `${this.baseUrl}/getTaskAndFiles/${id}/${Date.now()}`
    );
  }

  getTaskByCaseId(id) {
    return this.http.get<TaskCase[]>(`${this.baseUrl}/getAll/${id}`);
  }

  updateStatusAndOrder(taskCases) {
    return this.http
      .put<TaskCase[]>(`${this.baseUrl}/statusAndOrder`, { taskCases })
      .pipe(take(1))
      .subscribe();
  }

  updateTaskCase(id, data) {
    return this.http.put<TaskCase[]>(`${this.baseUrl}/update/${id}`, data);
  }

  deleteTaskCase(id) {
    return this.http.delete<TaskCase[]>(`${this.baseUrl}/delete/${id}`);
  }

  createTaskCases(caseid, ids) {
    return this.http.post<TaskCase[]>(`${this.baseUrl}/createMany/${caseid}`, {
      ids,
    });
  }
}
